import { useCurrentUser } from "@src/context/UserContext";
import { useFeatureFlag } from "@src/backpack-console/featureFlags";
import { useQuery as useReactQuery } from "@tanstack/react-query";
import FetchClients, { ClientPaths } from "../client";
import { throwBackpackResponseError } from "../errors";

const search = {
  useQuery,
};

export default search;

type SitesSearchQuery =
  ClientPaths["site"]["/search"]["get"]["parameters"]["query"];
export type SitesSearchResult =
  ClientPaths["site"]["/search"]["get"]["responses"]["200"]["content"]["application/json"];

const SITE_SEARCH_KEY = "siteSearch";

async function getSiteSearch(query: SitesSearchQuery) {
  const { data, error } = await FetchClients.site.GET("/search", {
    params: {
      query,
    },
  });
  if (data) return data;
  throwBackpackResponseError(error);
}

function useQuery(query: SitesSearchQuery) {
  const { superAdmin } = useCurrentUser();
  const isInactiveSitesEnabled =
    useFeatureFlag("inactive-sites", "off") === "on" && superAdmin;

  const finalQuery: SitesSearchQuery = {
    ...query,
    // Query length must be at least 2, or else it is ignored
    query: (query?.query?.trim().length ?? 0) < 2 ? undefined : query?.query,
    status: isInactiveSitesEnabled ? undefined : "active",
  };

  return useReactQuery({
    queryKey: [SITE_SEARCH_KEY, finalQuery],
    queryFn: () => getSiteSearch(finalQuery),
    refetchOnMount: false,
    staleTime: 60000,
  });
}
